import InstrumentIcon from "../../../instrument-icon";
import Big from "big.js";
import {useSelector} from "react-redux";
import {Tooltip} from "react-tooltip";


const GeneralStatsItem = props => {

    const {stat, handleBetDetail} = props
    const {
        selectedFiat,
        fiatRates
    } = useSelector(state => state.authenticationReducer)

    const {symbols} = useSelector(state => state.globalReducer)

    return (
        <tr key={stat?.timestamp}>
            <td>
                <div className="xtable__text">
                    <a onClick={e => handleBetDetail(stat)}>{stat?.game_name}</a>
                </div>
            </td>
            <td>
                <div
                    className={`xtable__coin ${stat?.multiplier >= 1 ? 'xtable__coin--green' : 'text-secondary'} gap-1`}>

                    <span>{symbols[selectedFiat]}</span>

                    <Tooltip className="tooltip-me" anchorSelect={`#win-amount-${stat.id}`}>
                        <span className="xtable__coin gap-1">
                            {
                                Big(stat?.wallet_income || 0).minus(parseFloat(stat?.multiplier) === 1 ? 0 : (stat?.wallet_amount || 0))
                                    .toFixed(8)
                            }
                            <InstrumentIcon code={stat?.wallet_currency}/>
                        </span>
                    </Tooltip>

                    <span id={`win-amount-${stat.id}`}>
                    {
                        selectedFiat ?
                            Big(stat?.wallet_income || 0).minus(parseFloat(stat?.multiplier) === 1 ? 0 : (stat?.wallet_amount || 0))
                                .div(fiatRates[stat.wallet_currency] || 1)
                                .toFixed(8)
                            : Big(stat?.wallet_income || 0).minus(parseFloat(stat?.multiplier) === 1 ? 0 : (stat?.wallet_amount || 0)).toFixed(8)

                    }
                    </span>

                    <InstrumentIcon code={stat?.wallet_currency}/>
                </div>
            </td>
        </tr>

    )

}

export default GeneralStatsItem
